export enum Direction {
  forward = 'forward',
  backward = 'backward'
}
